import React from 'react';
import { TextAreaLabel } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import css from '../../styles.module.css';

export default function CommentInput({ comment, onChange = () => {}, onFocus = () => {} }) {
    const { t } = useTranslation();

    const handleChange = React.useCallback(
        e => {
            if (e.target.value === '') {
                return onChange('comment', null);
            }
            return onChange('comment', e.target.value);
        },
        [onChange]
    );

    return (
        <TextAreaLabel
            className={css['attendees-textarea-comments']}
            label={t('attendees.addAttendees.comments')}
            placeholder={t('attendees.addAttendees.textAreaPlaceholder')}
            value={comment}
            onChange={handleChange}
            onFocus={onFocus}
        />
    );
}
